class Providers{

    constructor(activeProv = 0, app_providers_datatable, cp_providers_datatable) {
        this.basicActions();
        this.activeProviders = activeProv;
        this.app_providers_datatable = app_providers_datatable;
        this.cp_providers_datatable = cp_providers_datatable;
    }
    basicActions(){

        const thisClass = this;
        $(document).on('click', '.add-provider', () => {
            $('input[name="is_admin_login"]').val(0);
            //we need to switch validation because of different modal
            thisClass.controlPanelLoginSettings('kt_modal_create_app', false);
        });

        $(document).on('click', '.add-provider-cp', () => {
            //we need to switch validation because of different modal
            thisClass.controlPanelLoginSettings('kt_modal_create_app', true);
        });

        $(document).on('click', '.edit-provider', (e) => {
            $('input[name="is_admin_login"]').val(0);
            this.redrawEditModal($(e.currentTarget).attr('data-uuid'), false);
        });


        $(document).on('click', '.edit-provider-cp', (e) => {
            $('input[name="is_admin_login"]').val(1);
            this.redrawEditModal($(e.currentTarget).attr('data-uuid'), true);
        });
        $(document).on('click', '.delete-provider', (e) => {
            this.deleteProvider($(e.currentTarget).attr('data-uuid'), false);
        });

        $(document).on('click', '.delete-provider-cp', (e) => {
            this.deleteProvider($(e.currentTarget).attr('data-uuid'), true);
        });

        $(document).on('click', '#editSeamlessDisabled', (e) => {
            //get old state of the checkbox
            let oldState = $(e.currentTarget).prop('checked');
            if($(e.currentTarget).hasClass('overflow')){
                this.checkIfSeamlessIsActive($(e.currentTarget), 'You cannot disable or enable Seamless Scalability because we haven’t received payment for the extra members exceeding your current limit.', true, oldState);
            }else if($(e.currentTarget).hasClass('no-subscription')) {
                this.checkIfSeamlessIsActive($(e.currentTarget), 'You cannot enable Seamless Scalability because you don’t have an active Stripe subscription.', false, oldState);
            }else{
                this.checkIfSeamlessIsActive($(e.currentTarget));
            }
        });

        $(document).on('click', '.activate-provider', (e) => {
            this.activateProvider($(e.currentTarget).attr('data-uuid'));
        });

        $(document).on('click', '.deactivate-provider', (e) => {
            this.deactivateProvider($(e.currentTarget).attr('data-uuid'));
        });

        $(document).on('click', '.deactivate-provider-cp', (e) => {
            this.deactivateProvider($(e.currentTarget).attr('data-uuid'), true);
        });

        $(document).on('click', '.activate-provider-cp', (e) => {
            this.activateProvider($(e.currentTarget).attr('data-uuid'), true);
        });

        $(document).on('click', '.token-generate', function () {
            $.ajax({
                url: '/sso-and-identity?do=generateToken',
                type: 'GET',
                dataType: '',
                data: { organizationID:findGetParameter('organizationID')}
            }).done(function (data) {
                $('#tokenInput').val(data);
                const el = document.querySelector('#tokenInput');
                el.select();
                document.execCommand('copy');
                toastr.success('Copied to clipboard!');
            });
        });

        $(document).on('click', '.token-generate-edit', function () {
            $.ajax({
                url: '/sso-and-identity?do=generateToken',
                type: 'GET',
                dataType: '',
                data: { organizationID:findGetParameter('organizationID')}
            }).done(function (data) {
                $('#tokenInputEdit').val(data);
                const el = document.querySelector('#tokenInputEdit');
                el.select();
                document.execCommand('copy');
                toastr.success('Copied to clipboard!');
            });
        });

        Providers.initSelect(true, '#kt_modal_create_app', '#kt_docs_select2_rich_content_create');

        // Ensure the Select2 dropdown closes when the modal is hidden
        $('#kt_modal_create_app').on('shown.bs.modal', function() {
            Providers.initSelect(true, '#kt_modal_create_app', '#kt_docs_select2_rich_content_create');
        });
    }

    static initSelect(isModal = false, modalString = '#kt_modal_edit_app', select2El = '#kt_docs_select2_rich_content')
    {
        var modal = $(modalString);

        // Format options
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }

            var span = document.createElement('span');
            var template = '';

            template += '<div class="d-flex align-items-center">';
            template += '<img src="' + item.element.getAttribute('data-kt-rich-content-icon') + '" class="h-40px me-3" alt="' + item.text + '"/>';
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-4 fw-bold lh-1">' + item.text + '</span>';
            template += '<span class="text-muted fs-5">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';

            span.innerHTML = template;

            return $(span);
        }


        // Toggle the modal

        // Wait for the modal to be fully shown
        if(isModal){
            modal.on('shown.bs.modal', function() {
                // Initialize or re-open Select2 dropdown
                let select2Element = $(select2El);
                select2Element.select2({
                    placeholder: "Select a Provider",
                    minimumResultsForSearch: Infinity,
                    templateSelection: optionFormat,
                    templateResult: optionFormat
                });

            });

            // Ensure the Select2 dropdown closes when the modal is hidden
            modal.on('hide.bs.modal', function() {
                if ($(select2El).hasClass("select2-hidden-accessible")) {
                    $(select2El).select2('destroy');
                }
            });

        } else {
            let select2Element = $(select2El);
            select2Element.select2({
                placeholder: "Select a Provider",
                minimumResultsForSearch: Infinity,
                templateSelection: optionFormat,
                templateResult: optionFormat,
                closeOnSelect: false
            }).on('select2:closing', function(e) {
                // Always prevent closing - attempt to keep it open
                e.preventDefault();
                select2Element.data('isOpen', false); // Reset flag
            }).on('select2:open', function(e) {
                // Check if the dropdown is open and if not, open it
                if (!select2Element.data('isOpen')) {
                    select2Element.select2('open');
                }
            });

        }
        $(select2El).on('select2:select', function (e) {
            $.ajax({
                url: '/sso-and-identity?do=getProviderInformation',
                type: 'GET',
                dataType: '',
                data: { organizationID:findGetParameter('organizationID'), providerID: $(this).val()}
            }).done(function (data) {
                //check if is_scim_supported is true and if not, change the text of scim stepper option
                if(data.id === 2 ){
                    $('.scim-supported').hide();
                    $('.scim-not-supported').hide();
                    $('.scim-supported-google').show();
                }
                else if(data.is_scim_supported === 0){
                    $('.scim-supported').hide();
                    $('.scim-not-supported').show();
                    $('.scim-supported-google').hide();
                }else{
                    $('.scim-supported').show();
                    $('.scim-not-supported').hide();
                    $('.scim-supported-google').hide();
                }
            });
        });
    }

    activateProvider(providerID, isCP = false)
    {
        Swal.fire({
            html: `<span class="text-center text-primary">Are you sure you want to enable this identity provider? `+(!isCP ? '<strong>All your blocked Members using this provider will be unblocked.</strong>' : '')+`</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, activate!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return fetch('/sso-and-identity/?do=activateProvider&organizationID='+findGetParameter('organizationID')+'&providerID='+providerID+'&isCP='+(isCP ? 1 : 0))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value === 'activated') {
                    if(isCP){
                        $(`.activate-provider-cp[data-uuid="${providerID}"]`).removeClass('activate-provider-cp').addClass('deactivate-provider-cp').attr('data-bs-content', 'Disable');
                    }else{
                        $(`.activate-provider[data-uuid="${providerID}"]`).removeClass('activate-provider').addClass('deactivate-provider').attr('data-bs-content', 'Disable');
                    }
                    this.activeProviders++;
                    toastr.success('Provider has been activated.');
                } else {
                    toastr.error('Unexpected error occurred. Please try it again later.');
                }
            } else {
                if(isCP){
                    $(`.activate-provider-cp[data-uuid="${providerID}"]`).children('input').prop('checked', false);
                }else{
                    $(`.activate-provider[data-uuid="${providerID}"]`).children('input').prop('checked', false);
                }
            }
        });
    }

    deactivateProvider(providerID, isCP = false)
    {
        if(this.activeProviders === 1 && isCP === false){
            Swal.fire({
                html: `<span class="text-center text-primary">You cannot deactivate the last provider. You must have at least one active provider.</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                showCancelButton: false,
                confirmButtonText: "Ok",
                customClass: {
                    confirmButton: 'btn btn-light-primary mt-0',
                },
            });
            // Verify the state change after reverting
            //no need to check if isCP because the only way to get here is if the provider is not CP
            $(`.deactivate-provider[data-uuid="${providerID}"]`).children('input').prop('checked', true);
            return;
        }

        let html = ``;
        if(!isCP){
            html = `
                    <span class="text-center text-primary">You are about to disable this identity provider, All Members using this identity provider will be <b>blocked</b>.<br> If you also want to delete these Members, check the checkbox:</span>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none" name="deleteMembersCheckBox" type="checkbox" value="" id="delMembersCheck" />
                        <label class="form-check-label text-primary" for="flexCheckDefault">
                            Delete Members
                        </label>
                    </div>
                   `
        } else {
            html = `<span class="text-center text-primary">You are about to disable this identity provider, All Admins using this identity provider will be <b>blocked</b>.<br> If you also want to delete these Admins, check the checkbox:</span>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none" name="deleteAdminsCheckBox" type="checkbox" value="" id="delAdminsCheck" />
                        <label class="form-check-label text-primary" for="flexCheckDefault">
                            Delete Admins
                        </label>
                    </div>`
        }

        Swal.fire({
            html: html,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, disable!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                const delMembersCheckbox = document.getElementById('delMembersCheck');
                const delAdminsCheckbox = document.getElementById('delAdminsCheck');
                let delMembersCheck = false;
                let delAdminsCheck = false;
                if(delMembersCheckbox){
                    delMembersCheck = delMembersCheckbox.checked;
                }
                if(delAdminsCheckbox){
                    delAdminsCheck = delAdminsCheckbox.checked;
                }

                return fetch('/sso-and-identity/?do=deactivateProvider&organizationID='+findGetParameter('organizationID')+'&providerID='+providerID+'&block='+(isCP ? (delAdminsCheck ? 0 : 1) : (delMembersCheck ? 0 : 1))+'&isCP='+(isCP ? 1 : 0))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value === 'deactivated') {
                    if(isCP){
                        $(`.deactivate-provider-cp[data-uuid="${providerID}"]`).removeClass('deactivate-provider-cp').addClass('activate-provider-cp').attr('data-bs-content', 'Enable');
                    }else{
                        $(`.deactivate-provider[data-uuid="${providerID}"]`).removeClass('deactivate-provider').addClass('activate-provider').attr('data-bs-content', 'Enable');
                    }
                    this.activeProviders--;
                    toastr.success('Provider has been deactivated.');
                } else {
                    toastr.error('Unexpected error occurred. Please try it again later.');
                }
            } else {
                if(isCP){
                    $(`.deactivate-provider-cp[data-uuid="${providerID}"]`).children('input').prop('checked', true);
                }else{
                    $(`.deactivate-provider[data-uuid="${providerID}"]`).children('input').prop('checked', true);
                }
            }
        });
    }

    deleteProvider(providerID, isCP = false)
    {
        Swal.fire({
            html: `<span class="text-center text-primary">Are you sure you want to remove this provider? <b>All of your `+(!isCP ? 'Members' : 'Admins')+` using this identity provider will be deleted</b>.</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, delete!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return fetch('/sso-and-identity/?do=removeProvider&organizationID='+findGetParameter('organizationID')+'&providerID='+providerID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value === 'deleted') {
                    if(isCP){
                        this.cp_providers_datatable.datatable.ajax.reload(null, false);
                    } else {
                        this.app_providers_datatable.datatable.ajax.reload(null, false);
                    }
                    toastr.success('Provider has been deleted.');
                } else {
                    toastr.error('Unexpected error occurred. Please try it again later.');
                }
            }
        });
    }

    redrawEditModal(id, isCp = false)
    {
        const mainClass = this;
        new ModalLoading();
        naja.makeRequest('GET', '/sso-and-identity?do=redrawLogin', {
            'organizationID': findGetParameter('organizationID'),
            'providerId': id,
            'isCp': isCp
        }, {
            history: false
        }).then((response) => {
            mainClass.bindCopy();

            Providers.initSelect(true, '#kt_modal_edit_app', '#kt_docs_select2_rich_content');
            //we need to switch validation, because of different modal
            mainClass.switchModalValidation('#frm-editIdentityProviderForm-editIdentityProviderForm', isCp, response.provider.uuid);
            new CreateModalStepper('#kt_modal_edit_app_stepper', '#kt_modal_edit_app');
            $('input[name="is_admin_login"]').val(isCp ? 1 : 0);

            new ModalLoading(document.getElementById('kt_modal_edit_app'));
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }

    bindCopy()
    {
        var btns = document.querySelectorAll('.copy-button');
        var clipboard = new ClipboardJS(btns);
        clipboard.on('success', function (e) {
            //check if trigger has class google-id

            if($(e.trigger).hasClass('google-id')){
                e.trigger.textContent = 'ID Copied'
            }else{
                e.trigger.textContent = 'URL Copied';
            }
            e.trigger.setAttribute('disabled', true);
            window.setTimeout(function () {
                if($(e.trigger).hasClass('google-id')){
                    e.trigger.textContent = 'Copy ID'
                }else{
                    e.trigger.textContent = 'Copy URL';
                }
                e.trigger.removeAttribute('disabled');
            }, 5000);
        });
        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
    }

    controlPanelLoginSettings(modalName, isCp = false){
        let mainClass = this;
        naja.makeRequest('GET', '/sso-and-identity/?do=redrawCp', {
            'organizationID': findGetParameter('organizationID'),
            'isCp': isCp,
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            $('#'+modalName).modal('toggle');
            mainClass.bindCopy();
            Providers.initSelect(true, '#kt_modal_create_app', '#kt_docs_select2_rich_content_create');
            //we need to switch validation, because of different modal
            console.log(response);
            mainClass.switchModalValidation('#frm-createIdentityProviderForm-createIdentityProviderForm', isCp);
            new CreateModalStepper('#kt_modal_create_app_stepper', '#kt_modal_create_app');
            $('input[name="is_admin_login"]').val(isCp ? 1 : 0);
        });
    }

    switchModalValidation(selector, isCP = false, providerID = null)
    {
        this.validateCreateIdentityProviderForm($(selector).attr('id'), isCP, providerID);
    }

    validateCreateIdentityProviderForm(formId, isCP = false, providerID = null)
    {
        if(step1Validator != null){
            step1Validator.resetForm();
            step1Validator = null;
            if(step3Validator != null){
                step3Validator.resetForm();
                step3Validator = null;
            }
            if(step4Validator !=null && !isCP){
                step4Validator.resetForm();
                step4Validator = null;
            }
        }

        let identityForm = document.getElementById(formId);

        if(identityForm){
            step1Validator = FormValidation.formValidation(
                identityForm,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Name cannot be over 64 characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/sso-and-identity/?do=checkNameUniqueness',
                                    async: false,
                                    data: function () {
                                        return {
                                            organizationID: findGetParameter('organizationID'),
                                            uuid: providerID
                                        };
                                    },
                                }
                            },
                        },
                        'category_id': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                name: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        message: new FormValidation.plugins.Message({
                            clazz: 'fv-plugins-message-container invalid-feedback',
                            container: function (field, ele) {
                                if ($(ele).attr('name') === 'category_id') {
                                    return $('#option_errors')[0];
                                } else {
                                    return $('#name_errors')[0];
                                }
                            },
                        }),
                    }
                },
            );

            step3Validator = FormValidation.formValidation(
                identityForm,
                {
                    fields: {
                        'sso_url': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 1000,
                                    message: 'Name cannot be over 64 characters',
                                },
                            },
                        },
                        'issuer': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                        'cert': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                hostname: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );
            if(!isCP && $(identityForm).find('.scim-supported').is(':visible')){
                console.log("yes");
                step4Validator = FormValidation.formValidation(
                    identityForm,
                    {
                        fields: {
                            'scim_jwt': {
                                validators: {
                                    callback: {
                                        message: 'This field is required',
                                        callback: function (input) {
                                            //check if parent .scim-supported is visible and if so return true

                                            if($(input.element).closest('.scim-supported').is(':visible') === false){
                                                return true;
                                            }
                                            if ($(input.element).hasClass('edit-token')) {
                                                if ($('#editScim')[0].checked) {
                                                    if ($(input.element).val() == '') {
                                                        return false;
                                                    }
                                                }
                                            } else {
                                                if ($('#createScim')[0].checked) {
                                                    if ($(input.element).val() == '') {
                                                        return false;
                                                    }
                                                }
                                            }

                                            return true;
                                        },
                                    },
                                },
                            },
                        },
                        plugins: {
                            trigger: new FormValidation.plugins.Trigger({
                                delay: {
                                    hostname: 0.5
                                },
                            }),
                            autoFocus: new FormValidation.plugins.AutoFocus(),
                            submitButton: new FormValidation.plugins.SubmitButton(),
                            bootstrap: new FormValidation.plugins.Bootstrap5({
                                rowSelector: '.fv-row',
                                eleInvalidClass: '',
                                eleValidClass: ''
                            }),
                        }
                    }
                );
            }
        }
    }

    checkIfSeamlessIsActive(elem, message = 'This feature is in Beta testing and is only available for chosen customers.', overflow = false, oldState = true) {
        let uuid = elem.attr('data-uuid');
        console.log(elem);
        console.log(message);
        Swal.fire({
            html: `<span class="text-center text-primary">${message}</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: false,
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            returnFocus: false,
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if(oldState === true){
                elem.prop('checked', false);
            }else{
                elem.prop('checked', true);
            }

        });
    }
}

let identityValidator = null;
let step1Validator = null;
let step3Validator = null;
let step4Validator = null;
function findGetParameter(parameterName)
{
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[1]);
            }
        });
    return result;
}

class CreateModalStepper
{
    constructor(stepperSelector, modalSelector)
    {
        // Stepper lement "#kt_modal_create_app_stepper"
        var element = document.querySelector(stepperSelector);
        if(element){
            // Initialize Stepper
            var stepper = new KTStepper(element);
            // Handle next step
            stepper.on("kt.stepper.next", function (stepper) {

                switch (stepper.currentStepIndex) {
                    case 1:
                        let submitButtons = document.querySelectorAll('button[data-kt-stepper-action="next"]');
                        submitButtons.forEach(function(button) {
                            button.setAttribute('data-kt-indicator', 'on');
                            button.disabled = true;
                        });

                        step1Validator.validate().then(function (status) {
                            submitButtons.forEach(function(button) {
                                button.setAttribute('data-kt-indicator', 'off');
                                // Disable button to avoid multiple click
                                button.disabled = false;
                            });
                            if (status === 'Valid') {
                                stepper.goNext();
                            }
                        });
                        break;
                    case 3:
                        step3Validator.validate().then(function (status) {
                            if (status === 'Valid') {
                                stepper.goNext();
                            }
                        });
                        break;
                    default:
                        stepper.goNext();
                }

            });

            // Handle navigation click
            stepper.on("kt.stepper.click", function (stepper) {

                let submitButtons = document.querySelectorAll('button[data-kt-stepper-action="next"]');
                submitButtons.forEach(function(button) {
                    button.setAttribute('data-kt-indicator', 'on');
                    button.disabled = true;
                });

                step1Validator.validate().then(function (status) {

                    submitButtons.forEach(function(button) {
                        button.setAttribute('data-kt-indicator', 'off');
                        // Disable button to avoid multiple click
                        button.disabled = false;
                    });
                    if (status !== 'Valid') {
                        stepper.goTo(1); // go to clicked step
                    }
                });
                if(stepper.getClickedStepIndex() >= 3){
                    step3Validator.validate().then(function (status) {

                        if (status !== 'Valid') {
                            stepper.goTo(3); // go to clicked step
                        }else{
                            stepper.goTo(stepper.getClickedStepIndex()); // go to clicked step
                        }
                    });
                }else{
                    stepper.goTo(stepper.getClickedStepIndex()); // go to clicked step
                }

            });

// Handle previous step
            stepper.on("kt.stepper.previous", function (stepper) {
                stepper.goPrevious(); // go previous step
            });

            $(document).on('click', `${stepperSelector} button[data-kt-stepper-action="submit"]`, function () {
                //check if step4Validator is null and if so validate step3Validator
                let thisClass = $(this);
                if(step4Validator === null){
                    step3Validator.validate().then(function (status) {
                        if (status === 'Valid') {
                            new DismissModal(modalSelector.replace('#','')).disable();
                            // Show loading indication
                            let submitButton = thisClass;
                            // Show loading indication
                            submitButton.attr('data-kt-indicator', 'on');
                            // Disable button to avoid multiple click
                            submitButton.prop('disabled', true);
                            $(stepperSelector).parent('form').submit();
                        }
                    });
                    return;
                }else{
                    new DismissModal(modalSelector.replace('#','')).disable();
                    let submitButton = thisClass;
                    // Show loading indication
                    submitButton.attr('data-kt-indicator', 'on');
                    // Disable button to avoid multiple click
                    submitButton.prop('disabled', true);
                    $(stepperSelector).parent('form').submit();
                }

            });
        }
    }
    init()
    {

    }
}


window.Providers = Providers;
window.CreateModalStepper = CreateModalStepper;